<style scoped lang="scss" src="./Protocol.scss"></style>
<template>
  <main class="protocol-screen">
    <section class="protocol-container">
      <div class="title">Aguarde...</div>
      <div class="texts">
        <div class="text">Estamos esperando o profissional para realizar o seu atendimento.</div>
        <div class="text">Aguarde, em breve, você será atendido.</div>
      </div>
      <!-- Exibe o protocolo gerado -->
      <div class="protocol">
        <div class="subtitle">Seu número de protocolo:</div>
        <div class="box">{{ protocol }}</div>
      </div>
      <!-- Exibe o cronômetro -->
      <div class="crono">
        <div class="subtitle">Tempo de espera:</div>
        <div class="box">{{ waitingTime }}</div>
      </div>
      <!-- Exibe o cronômetro -->
      <div class="crono">
        <div class="subtitle">Qualidade da Conexão:</div>
        <!-- ANTENA -->
        <div class="box">
          <div class="bars">
            <div class="bar one" :class="{'off': connectionLevel < 1, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
            <div class="bar two" :class="{'off': connectionLevel < 2, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
            <div class="bar three" :class="{'off': connectionLevel < 3, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
            <div class="bar four" :class="{'off': connectionLevel < 4, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
            <div class="bar five" :class="{'off': connectionLevel < 5, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
          </div>
          <div class="text-connection"
          :class="{
            'off': connectionLevel < 1,
            'yellow': connectionColor === 'yellow',
            'red': connectionColor === 'red'}"
          >{{ connectionLabel }}</div>
        </div>
      </div>
      <!-- Permissoes -->
      <div class="permissions">
        <div class="subtitle">Suas permissões:</div>
        <div class="permission-item">
          <div class="key">Permissão de acesso ao microfone:</div>
          <div class="value">
            <div class="on" v-if="permissionCamera"><i class="fas fa-check-circle"></i></div>
            <div class="off" v-if="!permissionCamera"><i class="fas fa-times-circle"></i></div>
          </div>
        </div>
        <div class="permission-item">
          <div class="key">Permissão de acesso à câmera:</div>
          <div class="value">
            <div class="on" v-if="permissionMicrophone"><i class="fas fa-check-circle"></i></div>
            <div class="off" v-if="!permissionMicrophone"><i class="fas fa-times-circle"></i></div>
          </div>
        </div>
      </div>
      <!-- Voltar -->
      <div class="back" @click="onClickBack">
        <p>Encerrar</p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "ProtocolScreen",
  props: {
    connectionLevel: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      protocol: "", // Armazena o protocolo gerado
      minutes: "00", // Minutos do cronômetro
      seconds: "00", // Segundos do cronômetro
      intervalId: null, // ID do intervalo do cronômetro
      permissionCamera: false,
      permissionMicrophone: false,
      waitingTime: '00:00',

      connectionLabel: null,
      connectionColor: null
    };
  },

  watch: {
    connectionLevel (val) {
      this.calcConnection(val)
    }
  },

  beforeDestroy() {
    // Limpa o cronômetro ao destruir o componente
    clearInterval(this.intervalId);
  },

  async mounted() {
    this.cpf = this.$route.query.cpf || null;
    if (this.cpf) {
      this.cpf = this.cpf.replace(/[.-]/g, '')
      this.protocol = this.makeProtocol(this.cpf);
    } else {
      console.error('[Protocol] ERRO: queryString CPF não informado')
    }

    // Inicia o cronômetro
    this.startTimer();

    this.calcConnection(this.connectionLevel)
    await this.checkMediaPermissionsCamera();
    await this.checkMediaPermissionsMicrophone();

  },

  methods: {
    calcConnection (level) {
      switch (level) {
        case 1:
          case 2:
          this.connectionColor = 'red';
          this.connectionLabel = 'Conexão Instável';
          break;
        case 3:
          this.connectionColor = 'yellow';
          this.connectionLabel = 'Conexão Estável';
          break;
        case 4:
          case 5:
            this.connectionColor = '';
          this.connectionLabel = 'Conexão Estável';
          break;
        default:
          this.connectionColor = 'red';
          this.connectionLabel = 'Sem Conexão';
          break;
      }
    },

    getWaitingTime () {
      return this.waitingTime
    },

    // Função para gerar o protocolo
    makeProtocol (cpf) {
      const date = new Date();

      const partCpf = cpf.slice(-4);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const ms = date.getMilliseconds().toString().padStart(3, "0").slice(-2);
      const partDate = `${day}${month}${ms}`;

      const carac = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let partRandom = "";
      for (let i = 0; i < 4; i++) {
        partRandom += carac.charAt(Math.floor(Math.random() * carac.length));
      }

      const protocol = `${partCpf}-${partDate}-${partRandom}`

      this.$emit('makeProtocol', protocol)
      return protocol;
    },

    // Função para iniciar o cronômetro
    startTimer() {
      let totalSeconds = 0;

      this.intervalId = setInterval(() => {
        totalSeconds++;

        // Calcula minutos e segundos
        this.minutes = Math.floor(totalSeconds / 60).toString().padStart(2, "0");
        this.seconds = (totalSeconds % 60).toString().padStart(2, "0");
        this.waitingTime = `${this.minutes}:${this.seconds}`
      }, 1000);
    },

    onClickBack () {
      this.$emit('finish', true)
    },

    /**
     * Verifica se a permissão de acesso à câmera está habilitada
     * e lida com erros de permissão ou ausência de câmera.
     * @async
     */
    async checkMediaPermissionsCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        console.log("Câmera está habilitada.");
        this.permissionCamera = true
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        if (error.name === "NotAllowedError") {
          console.log("Acesso à câmera foi negado.");
        } else if (error.name === "NotFoundError") {
          console.log("Câmera não encontrada.");
        } else {
          console.log("Erro ao acessar a câmera: ", error);
        }
        this.permissionCamera = false
      }
    },
    /**
     * Verifica se a permissão de acesso ao microfone está habilitada
     * e lida com erros de permissão ou ausência de microfone.
     * @async
     */
    async checkMediaPermissionsMicrophone() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        console.log("Microfone está habilitado.");
        this.permissionMicrophone = true
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        if (error.name === "NotAllowedError") {
          console.log("Acesso à microfone foi negado.");
        } else if (error.name === "NotFoundError") {
          console.log("Microfone não encontrado.");
        } else {
          console.log("Erro ao acessar o microfone: ", error);
        }
        this.permissionMicrophone = false
      }
    },
  }
};
</script>

